<template>

  <v-dialog
    v-model="show"
    persistent
    width="720"
    >
    <div style="padding: 6px;">
    <v-toolbar class="ma-1"  dense  elevation="0" rounded>
            <v-icon left >mdi-playlist-plus</v-icon><span class="va-underline">{{state=='new'?'Create':'Modify'}} Customer </span>
            <v-spacer/>
            <v-btn fab x-small elevation="1" color="warning"  @click="emitToParent('close')"><v-icon >mdi-close</v-icon></v-btn>
          </v-toolbar>
    <v-row no-gutters>
      <v-col cols="12">
        <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
          <v-card class="ma-1">
            <v-card-text>
                    <table class="va-table va-align-top">
                      <tr>
                        <td> 
                            <v-radio-group
                                v-model="customer.type"
                                row
                                dense
                              >
                                <v-radio
                                v-for="(ct,t) in GET_SYSVARS('customer_types')"
                                :key="t"
                                  :label="ct"
                                  :value="ct"
                                ></v-radio>
                              </v-radio-group>
                         </td>
                         <td class="text-right">
                            
                         </td>
                      </tr>    
                      <tr>
                        <td width="50%" class="pa-2">
                          
                          <v-divider class="mb-4" color=""/>
                          <div class="text-center mb-2">
                                  <v-avatar   size="120" v-if="files.profile_picture">
                                  <img
                                  :src="files.profile_picture"
                                  >
                                  </v-avatar>
                            <zera-s3-upload :show="s3upload" @zeraEvent="s3Ev"/>
                        
                            <div class="text-body-small">Profile Picure</div>
                          </div>
                          <v-row no-gutters>
                            <v-col cols="4">
                              <v-combobox
                              v-model="profile.title"
                              dense
                              label="Title"
                              :items="['Mr.', 'Mrs.', 'Ms.']"
                            />
                             </v-col>
                             <v-col cols="8">
                              <v-text-field
                               v-model="profile.firstname"
                              dense
                              :rules="textRules"
                              label="First Name"
                            />
                            </v-col>
                            <v-col cols="9">
                                  <v-text-field
                                  v-model="profile.lastname"
                                 
                                  dense
                                  label="Last Name"
                                />
                             </v-col>
                             <v-col cols="3">
                              <v-text-field
                               v-model="profile.middle"
                              dense
                              label="M.I"
                            />
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                              v-model="profile.birthdate"
                              dense
                              label="Date of Birth"
                            />
                            </v-col>
                          </v-row> 
                         

                          
                           
                          
                      </td>
                      <td class="pa-2"> 
                        <span  class="text-secondary px-3 lightgray">Contact Information</span>  
                          <v-divider class="mb-4" color=""/>
                          <v-row no-gutters>
                           
                            <v-col cols="6">
                                  <v-text-field
                                  v-model="contact.telephone"
                                  dense
                                 label="Telephone No."
                                />
                             </v-col>
                             <v-col cols="6">
                              <v-text-field
                               v-model="contact.mobile"
                             
                              dense
                              label="Mobile No."
                            />
                            </v-col>
                          </v-row> 
                         
                            <v-text-field
                              v-model="contact.email"
                              dense
                              label="Email Address"
                            />

                            <span class="text-secondary px-3 lightgray">Company</span>   
                            <v-divider class="mb-4"/>
                            <v-text-field
                              dense
                              v-model="company.name"
                              label="Company Name"
                            />
                            <v-text-field
                            v-model="company.position"
                              dense
                              label="Job Position"
                            />

                      </td>
                     
                      </tr>

                      <tr>
                        <td width="50%" class="pa-2">
                          <span class="text-secondary px-3 lightgray">Billing Address</span>   
                          <v-divider class="mb-4"/>
                          
                        
                            <v-row no-gutters>
                              <v-col cols="12">
                                <v-text-field
                                   v-model="billing.line_address"
                                    dense
                                    label="Address"
                                  />
                               </v-col> 
                              <v-col cols="6">
                                <v-text-field
                                 v-model="billing.municipality"
                                  dense
                                  label="City/Municipality"
                                />
                              </v-col>
                              <v-col cols="6">
                                <v-text-field
                                  v-model="billing.province"
                                  dense
                                  label="State/Province"
                                />
                              </v-col>
                              <v-col cols="8">
                                <v-text-field
                                  dense
                                   v-model="billing.region"
                                  label="Region"
                                />
                              </v-col>
                              <v-col cols="4">
                                <v-text-field
                                  v-model="billing.zip"
                                  dense
                                  label="ZIP Code"
                                />
                              </v-col>
                              <v-col cols="12">
                                    <v-text-field
                                    v-model="billing.country"
                                  dense
                                  label="Country"
                                />
                                  </v-col>
                            </v-row>
                           
                        </td>
                        <td width="50%" class="pa-2">
                          
                          <span  class="text-secondary px-3 lightgray">Delivery Address </span>   
                          <span style="float: right; margin-top:-8px">
                            <v-checkbox  v-model="same_address" @change="sameAddress()" 
                            hide-details label="Same as billing" dense/> 
                          </span>
                          <v-divider class="mb-4"/>
                          <v-row no-gutters>
                              <v-col cols="12">
                                <v-text-field
                                   v-model="delivery.line_address"
                                    dense
                                    label="Address"
                                  />
                               </v-col> 
                              <v-col cols="6">
                                <v-text-field
                                 v-model="delivery.municipality"
                                  dense
                                  label="City/Municipality"
                                />
                              </v-col>
                              <v-col cols="6">
                                <v-text-field
                                  v-model="delivery.province"
                                  dense
                                  label="State/Province"
                                />
                              </v-col>
                              <v-col cols="8">
                                <v-text-field
                                  dense
                                   v-model="delivery.region"
                                  label="Region"
                                />
                              </v-col>
                              <v-col cols="4">
                                <v-text-field
                                  v-model="delivery.zip"
                                  dense
                                  label="ZIP Code"
                                />
                              </v-col>
                              <v-col cols="12">
                                    <v-text-field
                                    v-model="delivery.country"
                                  dense
                                  label="Country"
                                />
                                  </v-col>
                            </v-row>
                        </td>
                       </tr>  
                    </table>
             </v-card-text> 
             <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn tile text small ripple  @click="emitToParent('close')">
                  <v-icon>mdi-close</v-icon>
                  <span>Cancel</span>
              </v-btn>
              <v-divider vertical class="mx-1"/>
              <v-btn color="success" small tile text ripple @click="loading=true,validate()">
                  <v-icon>mdi-disc</v-icon>
                   <span>{{state=='new'?'Create':'Save'}}</span>
              </v-btn> 
              <v-spacer></v-spacer>
             </v-card-actions>
          </v-card>
        </v-form>  
      </v-col>
        

    </v-row>      
  </div>
  
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    selectedID: {
       type: Number,
        default: null
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      loading: false,
      same_address:false,
      newpassword:'',
      show1: false,
      customer: { type:'Individual'},
      profile: { title:"", firstname:"",lastname:"", middle:"", birthdate:""},
      contact:{telephone:"", mobile:"",email:""},
      company:{name:"", position:""},
      files: {profile_picture:""},
      billing:{},
      delivery:{},
      franchiselist:[],
      licenses:[],
      s3upload: true,
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      },
      STATUS() {
        return ['New Application', 'Under-construction', 'Active', "Closed"]
      }
  },
  watch: {
    show (v) {
      if (v) {
        if(this.state=='new'){
          this.customer.profile  = this.profile
          this.customer.contact  = this.contact
          this.customer.address  = this.address
        } else {
            this.getCustomer()
        }
      } 
    }
  },
  methods: {
  clear(){
     this.profile = { title:"", firstname:"",lastname:"", middle:"", birthdate:""}
      this.contact= {telephone:"", mobile:"",email:""}
      this.company = {name:"", position:""}
      this.files = {profile_picture:""}
      this.s3upload = true
  },
     validate () {
       
        if (this.$refs.form.validate()) {
            if(this.state=='new') {
              this.Create()
            } else {
              this.Update()
            }
            
        }
      },
     s3Ev(e){
        this.s3upload = false
        this.files.profile_picture = e[0]
        console.log("image:",  this.files.profile_picture)
      },
    sameAddress(){
      if(this.same_address) {
        this.delivery=this.billing
      } 
     
    },
    emitToParent () {
      this.clear()
        this.$emit('DialogEvent', "")
    },
     Update(){
          this.customer.profile  = this.profile
          this.customer.contact  = this.contact
          this.customer.company  = this.company
          this.customer.address  = {billing:this.billing,delivery:this.delivery }
          this.customer.files = this.files
           this.$http.post("update_customer", this.customer).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          if(response.data.status){
              this.emitToParent()
          }
        }).catch(e => {
          console.log(e.data)
        })
    },
    Create(){
          var address = {billing:this.billing,delivery:this.delivery }
           var userID = this.$IsNum(this.$session.get('userID'))
          let params = {
                  table: "customers", 
                  type:"newdata",
                  query:`INSERT INTO customers(created_on, created_by, type, profile, contact, company, address, files)
                        VALUES (NOW(), ${userID}, '${this.customer.type}', '${JSON.stringify(this.profile)}'::jsonb,
                        '${JSON.stringify(this.contact)}'::jsonb,
                        '${JSON.stringify(this.company)}'::jsonb,
                        '${JSON.stringify(address)}'::jsonb,
                        '${JSON.stringify(this.files)}'::jsonb
                        )`
              }
              console.log(params)
            this.$http.post("new_data", params).then(response => {
              console.log(response)
              this.loading = false
              this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
              this.emitToParent('close')
            }).catch(e => {
              console.log(e.data)
            })

    },
    getCustomer() { 
        
           this.customer = {}
            this.QUERY('vendors',`select * from customers where id = ${this.selectedID} order by id desc`, (res)=>{
              console.log(res)
              if(res.status) {
                  this.customer = res.results[0]
                 this.profile = this.customer.profile
                  this.contact = this.customer.contact
                  this.address = this.customer.address
                  this.files = this.customer.files
              }
              
            })
        }
  }
}
</script>
